import { co2 } from './common';

export default {
  'consumption.co2': `Kombinirane emisije ${co2}`,
  'consumption.energy': 'Poraba energije v kombinirani testni vožnji',
  'consumption.fuel': 'Kombinirana poraba goriva',
  'footnotes.local': '',
  'footnotes.wltp':
    'Navedene vrednosti so bile pridobljene v skladu s predpisanim postopkom merjenja. To so »vrednosti CO2 po protokolu WLTP« v povezavi s 3. točko 2. člena Izvedbene Uredbe (EU) 2017/1153. Vrednosti porabe goriva so bile izračunane na podlagi teh vrednosti. Poraba električne energije je bila določena na podlagi Uredbe (EU) 2017/1151 in Uredbe (ES) 692/2008. Podatki se ne nanašajo na posamezno vozilo in niso sestavni del ponudbe, ampak služijo le za primerjavo med različnimi tipi vozil. Vrednosti se razlikujejo glede na izbrano dodatno opremo.',
  'footnotes.nedc': '',
  'footnotes.emissions.appendix':
    'Za več informacij o uradni porabi goriva in emisijah CO2 novih osebnih vozil se obrnite na svojega pooblaščenega prodajalca vozil Mercedes-Benz.',
  'search.input.label': 'Vaš iskalni pojem/konfigurator OnlineCode',
  'search.result.buy-online': 'Kupite prek spleta',
  'search.results.count': 'število zadetkov iskanja: {count}',
  'search.results': 'Brez zadetkov | število zadetkov iskanja: {count} | število zadetkov iskanja: {count}',
  'search.results.backup': 'Ni natančnega ujemanja. Oglejte si sorodne strani:',
  'search.results.none.summary': 'Za ta iskalni pojem ni na voljo zadetkov iskanja. Poskusite ponovno z drugim pojmom.',
  'search.show-more': 'Več',
  'search.unavailable': 'Iskanje trenutno ni na voljo.',
  'search.result.new': 'Novo',
  'input.placeholder': 'Vaš iskalni pojem/konfigurator OnlineCode',

  'suggestions.all_search_results': 'Vsi rezultati iskanja',
  'suggestions.all_search_results_for': 'Prikaži vse rezultate za',
  'suggestions.in': 'v',

  all: 'Vse',
  UCOS: 'Spletna trgovina z rabljenimi vozili',
  PASSENGER_CARS: 'Osebna vozila',
  VANS: 'Dostavna vozila',
  NCOS: 'Spletna trgovina z novimi vozili',
  VIDEO: 'Videoposnetki',
  DEALER_LOCATOR: 'Iskanje trgovca',
  CONFIGURATOR: 'Konfigurator',
  TEST_DRIVE: 'Poskusna vožnja',
  VEHICLE_SEARCH: 'Iskalnik rabljenih vozil',
  COLLECT: 'Kolekcija in dodatna oprema',
  CONNECT: 'Trgovina Mercedes me Store',

  'search.result.consumption': 'Potrošnja',
  'watch.video': 'Oglejte si videoposnetek',
  'input.recently': 'Nedavno iskano',
  'input.help.title': 'Kaj morate iskati?',
  'input.help.text':
    'Iskanje po tipih vozila, modelih, konfiguracijskih kodah ali po dodatni opremi, drugih izdelkih in informacijah',

  'search.result.grid': 'Mreža',
  'search.result.list': 'Številka',

  // Empty result
  'support.check': 'Prosimo, preverite črkovanje ali poskusite znova z drugim izrazom.',
  'support.no.results': 'Za ta iskalni izraz ni zadetkov.',
  'support.no.results.term': 'Ni zadetkov',
  'support.chat': 'Ne najdete, kar iščete? Prosimo, uporabite naše. ',
  'support.chat.with.us': 'Podpora prek spletnega klepeta.',
};
